const SERVICE_WORKER_PATH = '/sw.js'
const AUTH_CONTEXT_EVENT = 'SYNC_WEB_PUSH_CONTEXT'

const getCookieValue = name => {
  if (typeof document === 'undefined')
    return null

  const cookies = document.cookie ? document.cookie.split(';') : []
  for (const cookie of cookies) {
    const [key, ...rest] = cookie.trim().split('=')
    if (key === name)
      return decodeURIComponent(rest.join('='))
  }

  return null
}

const buildAuthContextPayload = () => ({
  type: AUTH_CONTEXT_EVENT,
  baseURL: import.meta.env.VITE_API_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : ''),
  token: getCookieValue('accessToken'),
})

async function syncServiceWorkerAuthContext(registration) {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator) || !registration)
    return null

  const payload = buildAuthContextPayload()
  if (!payload.baseURL)
    return null

  const targetRegistration = registration.active
    ? registration
    : await navigator.serviceWorker.ready.catch(() => null)

  if (!targetRegistration?.active)
    return null

  targetRegistration.active.postMessage(payload)
  return targetRegistration
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator))
    return null

  if (!window.isSecureContext)
    return null

  try {
    const registration = await navigator.serviceWorker.register(SERVICE_WORKER_PATH)
    await syncServiceWorkerAuthContext(registration)
    return registration
  }
  catch (error) {
    console.error('Failed to register service worker', error)
    return null
  }
}

export async function getServiceWorkerRegistration() {
  if (!('serviceWorker' in navigator))
    return null

  const existing = await navigator.serviceWorker.getRegistration()
  if (existing) {
    await syncServiceWorkerAuthContext(existing)
    return existing
  }

  return registerServiceWorker()
}

export async function syncWebPushAuthContext() {
  if (!('serviceWorker' in navigator))
    return null

  const registration = await navigator.serviceWorker.getRegistration()
  if (!registration)
    return null

  return syncServiceWorkerAuthContext(registration)
}
